import { requireSupabase } from "@/lib/supabaseClient";
import { guard } from "@/lib/errors";

export const BUCKETS = {
  PROPERTY_IMAGES: "property-images",
  PROPERTY_VIDEOS: "property-videos",
  PROPERTY_DOCUMENTS: "property-documents",
  PROFILE_PHOTOS: "profile-photos",
  COMPANY_LOGOS: "company-logos",
};

function uniquePath(userId, file) {
  const ext = file?.name?.split(".").pop() || "bin";
  const rand = Math.random().toString(36).slice(2, 10);
  return `${userId || "anon"}/${Date.now()}-${rand}.${ext}`;
}

export const storageService = {
  upload: (bucket, file, { userId, path } = {}) =>
    guard("storageService.upload", async () => {
      const supabase = requireSupabase();
      const objectPath = path || uniquePath(userId, file);
      const { error } = await supabase.storage.from(bucket).upload(objectPath, file, {
        cacheControl: "3600",
        upsert: false,
      });
      if (error) throw error;
      const { data } = supabase.storage.from(bucket).getPublicUrl(objectPath);
      return { path: objectPath, publicUrl: data?.publicUrl };
    }),

  remove: (bucket, path) =>
    guard("storageService.remove", async () => {
      const supabase = requireSupabase();
      const { error } = await supabase.storage.from(bucket).remove([path]);
      if (error) throw error;
      return true;
    }),

  signedUrl: (bucket, path, expiresIn = 3600) =>
    guard("storageService.signedUrl", async () => {
      const supabase = requireSupabase();
      const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, expiresIn);
      if (error) throw error;
      return data?.signedUrl;
    }),
};
